export function deepClone(obj) {
    // Primitivos y funciones: se devuelven tal cual
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
  
    // Date
    if (obj instanceof Date) {
      return new Date(obj.getTime());
    }
  
    // RegExp
    if (obj instanceof RegExp) {
      return new RegExp(obj.source, obj.flags);
    }
  
    // Arrays
    if (Array.isArray(obj)) {
      return obj.map(item => deepClone(item));
    }
  
    // Objetos genéricos
    const copy = Object.create(Object.getPrototypeOf(obj));
    for (const key of Object.keys(obj)) {
      const val = obj[key];
      // Si es función, la copiamos por referencia; si no, clonamos recursivamente
      copy[key] = typeof val === 'function'
        ? val
        : deepClone(val);
    }
    return copy;
  }
  


// WEBPACK FOOTER //
// ./src/helpers/clone.helper.js